export default __webpack_public_path__ + "static/media/pan-caja.38fbfa84.jpg";